import { useSyncExternalStore } from "react";

function subscribe(callback) {
  window.addEventListener("online", callback);
  window.addEventListener("offline", callback);
  return () => {
    window.removeEventListener("online", callback);
    window.removeEventListener("offline", callback);
  };
}

function getSnapshot() {
  return navigator.onLine;
}

/**
 * Tracks browser connectivity. `false` is reliable (no network interface),
 * but `true` only means an interface is up — the server may still be
 * unreachable, so a failed request remains the authoritative signal.
 */
export default function useOnlineStatus() {
  return useSyncExternalStore(subscribe, getSnapshot);
}
